/*
 * @Author: 吴俊杰_20717 20717@etransfar.com
 * @Date: 2022-12-25 14:00:54
 * @LastEditors: 吴俊杰_20717 20717@etransfar.com
 * @LastEditTime: 2022-12-26 15:06:17
 * @FilePath: /lytMobile/src/routes/personalInfo/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import styles from './index.less';
import { jumpToUserInfo, jumpToAuthInfo, jumpToAccountSecurity, jumpToContract, jumpToCommonAddress } from '../../../utils/jsBridge';
import {mobileNumberChange, setTitle} from '../../../utils/utils'
export default class BasicInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {} 
    setTitle('用户基本信息');
  }

  componentDidMount() {

  }

  render() {
    let countParams = this.props.location.query;
    console.log('222', countParams)
    return (
      <div className={styles.basicInfo}>
        <div className="card">
            <b className="title">个人信息</b>
            <div className="list"><div className="label">使用目的</div><div className="info">完善账号信息</div></div>
            <div className="list"><div className="label">使用场景</div><div className="info">用户注册账号、登录时</div></div>
            <div className="list"><div className="label">收集情况</div><div className="info">收集1条</div></div>
            <div className="list"><div className="label">信息内容</div><div className="info click" onClick={() => jumpToUserInfo()}>个人信息</div></div>
        </div>
        <div className="card">
            <b className="title">手机号码</b>
            <div className="list"><div className="label">使用目的</div><div className="info">注册账号；身份验证；联系客服</div></div>
            <div className="list"><div className="label">使用场景</div><div className="info">用户首次注册账号；使用手机号登录、验证身份时；联系客服时</div></div>
            <div className="list"><div className="label">收集情况</div><div className="info">收集1条</div></div>
            <div className="list"><div className="label">信息内容</div><div className="info">{countParams.mobileNumber && mobileNumberChange(countParams.mobileNumber)}</div></div>
        </div>
        <div className="card">
            <b className="title">身份认证信息</b>
            <div className="list"><div className="label">使用目的</div><div className="info">注册账号；身份验证</div></div>
            <div className="list"><div className="label">使用场景</div><div className="info">用户首次注册账号；企业认证时</div></div>
            <div className="list"><div className="label">收集情况</div><div className="info">收集{countParams.authCount}条</div></div>
            <div className="list"><div className="label">信息内容</div><div className="info click" onClick={() => jumpToAuthInfo()}>认证信息</div></div>
        </div>
        <div className="card">
            <b className="title">地址管理</b>
            <div className="list"><div className="label">使用目的</div><div className="info">完成下单</div></div>
            <div className="list"><div className="label">使用场景</div><div className="info">用户下单时</div></div>
            <div className="list"><div className="label">收集情况</div><div className="info">收集{countParams.addressCount}条</div></div>
            <div className="list"><div className="label">信息内容</div><div className="info click"  onClick={() => jumpToCommonAddress()}>常用地址</div></div>
        </div>
        <div className="card">
            <b className="title">合同管理</b>
            <div className="list"><div className="label">使用目的</div><div className="info">在陆运通APP开展业务</div></div>
            <div className="list"><div className="label">使用场景</div><div className="info">用户与主体公司首次达成合作；经营信息变更重新签订协议时</div></div>
            <div className="list"><div className="label">收集情况</div><div className="info">收集{countParams.contractCount}条</div></div>
            <div className="list"><div className="label">信息内容</div><div className="info click" onClick={() => jumpToContract()}>合同管理</div></div>
        </div>
        <div className="card">
            <b className="title">账号及密码</b>
            <div className="list"><div className="label">使用目的</div><div className="info">注册账号</div></div>
            <div className="list"><div className="label">使用场景</div><div className="info">用户首次注册账号时</div></div>
            <div className="list"><div className="label">收集情况</div><div className="info">收集1条</div></div>
            <div className="list"><div className="label">信息内容</div><div className="info click" onClick={() => jumpToAccountSecurity()}>账户与安全</div></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/personalInfo/basicInfo/index.js